
<div class="content">
  <privacy-snack-bar (triggerGoogleLogin)="privacyDismissed($event)" *ngIf="showPrivacyAgreement">
  </privacy-snack-bar>
  <div class="body">
    <div class="section primary">
      <div class="container">
        <span class="title">Sign in</span>
        <div class="text-field">
          <span class="title">Email</span>
          <input type="text" name="username" id="username" class="input" [(ngModel)]="email" placeholder="Your Email" maxlength="255" [disabled]="waiting || showPrivacyAgreement" />
        </div>
        <div class="text-field">
          <span class="title">Password</span>
          <div class="input-container">
            <input [type]="passwordShowing ? 'text' : 'password'"  name="password" id="password" class="input" [(ngModel)]="password"
                placeholder="Your Password" [disabled]="waiting || showPrivacyAgreement" />
            <div class="inline-text-button" (click)="togglePasswordShowing()">{{passwordShowing ? 'Hide' : 'Show'}}</div>
          </div>
        </div>
        <div class="options small-margin-options">
          <div class="option">
            <mat-checkbox color="primary" class="checkbox" [(ngModel)]="rememberMe" [disabled]="waiting || showPrivacyAgreement">Remember me</mat-checkbox>
          </div>
          <button mat-button class="option text-button custom-size custom-color custom-disabled-color forgot" [disabled]="waiting || showPrivacyAgreement" (click)="forgotClicked()">Forgot password?</button>
        </div>
        <div class="buttons  margin-bottom">
          <button mat-button class="button primary full-width" [disabled]="!canDoLogin() || showPrivacyAgreement" (click)="doLogin()">
            <span *ngIf="waiting != 'login'">Sign in</span>
            <mat-progress-spinner *ngIf="waiting == 'login'" class="spinner" mode="indeterminate" diameter="25"></mat-progress-spinner>
          </button>

        </div>

        <div class="buttons">
           <button mat-button class="button secondary full-width"  (click)="doSamlAuth()" type="button" color="primary">Sign in via JH.edu</button>
        </div>
        <div class="buttons margin-bottom">
            <button mat-button class="button secondary full-width" [disabled]="waiting || showPrivacyAgreement" (click)="goToCompleteRegistration()">Complete registration</button>
        </div>
        <div class="text-buttons">
          <a href="https://www.huddyhealth.com/privacyPolicy" target="_blank" class="text-button-container">
            <button mat-button class="text-button custom-size custom-color" tabindex="-1"
              [disabled]="waiting || showPrivacyAgreement">Privacy Policy</button>
          </a>
        </div>
      </div>
    </div>
    <div class="section secondary"></div>
  </div>
</div>
